import produce from 'immer';
import gql from 'graphql-tag';
import { updateBooleanQueryString } from './updateQueryString';
import { parse } from 'qs';
// QUERY
export const boolFilterValue = function boolFilterValue(parent) {
    return (searchParams) => {
        var _a;
        const query = __IN_SERVER__ ? searchParams : document.location.search;
        const parsed = parse(query, {
            ignoreQueryPrefix: true
        });
        let result;
        if (typeof ((_a = parsed.boolean) === null || _a === void 0 ? void 0 : _a[parent.id]) !== 'undefined') {
            result = parsed.boolean[parent.id] === 'true';
        }
        else {
            result = parent.default;
        }
        return result ? true : false;
    };
};
////////////////////////////////////////////////////////////////////////////////
// MUTATION
export const setBoolFilter = (_, { value, id }, { cache, getCacheKey }) => {
    const fragmentId = getCacheKey({
        id,
        __typename: 'BooleanFilter'
    });
    const boolFilter = cache.readFragment({
        fragment: gql `
      fragment BoolFilterState on BooleanFilter {
        id
        default
        value @client
      }
    `,
        id: fragmentId
    });
    const data = produce(boolFilter, draft => {
        if (draft.default !== null) {
            draft.value = value === draft.default ? null : value;
        }
        else {
            draft.value = value === false ? null : value;
        }
    });
    cache.writeData({
        id: fragmentId,
        data
    });
    // Update the active filters in cache
    const activeFilters = updateActiveFilters(cache, data);
    updateBooleanQueryString(activeFilters);
    return data;
};
function updateActiveFilters(cache, data) {
    const activeBoolFilterQuery = gql `
    query GetActiveBoolFilters {
      activeFilters @client {
        booleanFilters {
          id
          value @client
        }
      }
    }
  `;
    const currentActiveFilters = cache.readQuery({ query: activeBoolFilterQuery });
    const { activeFilters } = produce(currentActiveFilters, draft => {
        // Clear this filter from active filters
        if (data.value === null) {
            draft.activeFilters.booleanFilters = draft.activeFilters.booleanFilters.filter(boolFilter => boolFilter.id !== data.id);
        }
        else {
            draft.activeFilters.booleanFilters.push({
                id: data.id,
                value: data.value,
                __typename: 'BooleanFilterInput'
            });
        }
    });
    cache.writeData({ data: { activeFilters } });
    return activeFilters;
}
//# sourceMappingURL=boolFilter.js.map